import React from 'react'
import PropTypes from 'prop-types'

const SidebarHeader = ({ onClose }) => (
  <div className="d-flex justify-content-between align-items-center bg-success text-white p-3">
    <h5 className="m-0">Edition groupée des variables</h5>
    <button type="button" className="close text-white" onClick={onClose}>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
)

SidebarHeader.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default SidebarHeader
